<template>
  <el-popover
    placement="bottom"
    width="720"
    trigger="hover"
    @show="getAddPayStat"
    @hide="onHide"
    :disabled="disabled || level == 'ad'"
  >
    <addPayPop
      v-if="show"
      :level="level"
      :id="_id"
      :data="data"
      v-loading="loading"
    ></addPayPop>
    <div slot="reference">
      <slot></slot>
    </div>
  </el-popover>
</template>

<script>
import addPayPop from './addPayPop';
export default {
  props: {
    id: String, //广告系列id
    level: String, //层级
    row: Object, //当前系列的数据对象
    api: Function, //接口函数
    platform: String, //平台
    params: Object, //额外的参数
    disabled: Boolean, //是否禁用
    accountId: String || Number, //广告账户id
  },
  components: { addPayPop },
  data() {
    return {
      addPayStat: {},
      loading: false,
      show: false,
    };
  },
  computed: {
    data() {
      if (!this.api) {
        return this.row;
      }
      console.log(this.addPayStat[this._id]);
      return this.addPayStat[this._id];
    },
    _id() {
      if (this.id) return this.id;
      if (this.level == 'campaign') {
        return this.row.ad.campaignId;
      } else {
        return this.row.ad.adGroupId;
      }
    },
    _accountId() {
      if (this.accountId) return this.accountId;
      return this.row.ad.adAccountId;
    },
  },
  methods: {
    getAddPayStat() {
      this.show = true;

      if (this.addPayStat[this._id] || this.addPayStat[this._id] === null || !this.api) {
        return;
      }
      let params = {
        ...this.params,
        actId: this._accountId,
        platform: this.platform,
        level: this.level,
        daysDiff: 7, // 统计时间天数，近7天传7  近15天传15
        ids: [this._id], //广告id  如果广告层级是系列传系列id，如果是组传组id
      };
      this.loading = true;
      this.api(params)
        .then((res) => {
          this.addPayStat = {
            ...res.data,
          };
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onHide() {
      this.show = false;
    },
  },
};
</script>
